import { GapiDAO } from './gapi.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HotelExtraInfoDataValidator } from './validators/data.validators';

const CLASS_NAME = 'HotelExtraInfoDao';
export const enum HotelExtraInfoType {
  ADDITIONALCHARGES = 'ADDITIONALCHARGES'
}

@Injectable()
export class HotelExtraInfoDao extends GapiDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService) {
    super(CLASS_NAME, http, appConfig, appConfig.hotelExtraInfoDAO, new DefaultRetryHandler(), new HotelExtraInfoDataValidator(), log);
  }

  public get(hotelMnemonic: string, infoType: HotelExtraInfoType = HotelExtraInfoType.ADDITIONALCHARGES): Observable<any> {
    const url = this.daoConfig.url
      .replace('{country}', this.appConfig.country)
      .replace('{language}', this.appConfig.language)
      .replace('{hotelMnemonic}', hotelMnemonic);
    return this.doGet(url, { type: infoType });
  };
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/hotel-extra-info.dao.ts